import { useTranslation } from 'react-i18next';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import {  useWageRequestFormButtonEnabled } from './helper';
import { EPLacementStatusRequirementTooltipType } from 'app/models/Placement/PlacementDetails';
import React from 'react';
import { TooltipListContent } from './utils';
export const DispatchWageRequestBtn = ({ currentPlacementStatus, existingDocuments, onClick = undefined, disabled = false }) => {
  const { t } = useTranslation();
  const { isEnabled, tooltipContent } = useWageRequestFormButtonEnabled(currentPlacementStatus, existingDocuments);
  return [
    {
      title: t('placement.wageRequestButton.name'),
      Icon: RequestQuoteOutlinedIcon,
      disabled: !isEnabled || disabled,
      tooltipProps: {
        tooltipContent: !isEnabled ? (
          <TooltipListContent
            tooltip={{
              message: t('placement.placementStatusPickList.disabledDueTo'),
              supportingList: tooltipContent,
              tooltipType: EPLacementStatusRequirementTooltipType.messageWithSupportList,
            }}
          />
        ) : (
          t('placement.wageRequestButton.buttonTooltip')
        ),
        disabled: false,
      },
      onClick: event => {
        onClick?.(event);
      },
    },
  ];
};
